import { Link, type LinkProps } from 'react-router-dom'

type AuthLinkProps = Omit<LinkProps, 'to'> & { to?: LinkProps['to'] }

export const AuthLink = ({
  to,
  onClick,
  style,
  children,
  ...props
}: AuthLinkProps) => {
  const isAction = to == null

  return (
    <Link
      to={to ?? '#'}
      onClick={(event) => {
        if (isAction) {
          event.preventDefault()
        }
        onClick?.(event)
      }}
      style={{ ...style, width: 'fit-content', textDecoration: 'underline' }}
      {...props}
    >
      {children}
    </Link>
  )
}
